import { Injectable } from '@angular/core';

import { Country } from 'src/app/models/Country';
import { GenericService } from 'src/app/services/api/generic.service';

@Injectable({
  providedIn: 'root'
})
export class CountryService extends GenericService<Country> {
  constructor() {
    super();
    this.setContext('countries');
  }
}
